<!--文件预览（word/pdf/ppt）：根据图片基础地址和页数展示转换后的图片，左右图标点击切换页码-->
<template>
    <div class="fip-container">
        <div class="fip-body">
            <img class="fip-image" :src="currentImgUrl" :alt="title" draggable="false" />
        </div>
        <template v-if="pagesNum > 1">
            <div class="fip-arrow fip-arrow-left" :class="{'fip-arrow-disabled': currentPage <= 1}"
                 @click="handlePrev">
                <el-icon><ArrowLeftBold /></el-icon>
            </div>
            <div class="fip-arrow fip-arrow-right" :class="{'fip-arrow-disabled': currentPage >= pagesNum}"
                 @click="handleNext">
                <el-icon><ArrowRightBold /></el-icon>
            </div>
            <div class="fip-page">{{ currentPage }} / {{ pagesNum }}</div>
        </template>
    </div>
</template>
<script>
export default {
    name: "fileImagePreview",
    props: {
        title: {
            type: String,
            default: '文件预览'
        },
        /*图片基础地址，页码图片为 imgUrl/1.png ~ imgUrl/pages.png*/
        imgUrl: {
            type: String,
            default: ''
        },
        /*文件页数*/
        pages: {
            type: [Number, String],
            default: 0
        },
    },
    data() {
        return {
            currentPage: 1,
        }
    },
    computed: {
        pagesNum() {
            return Number(this.pages) || 0;
        },
        currentImgUrl() {
            if (!this.imgUrl || this.pagesNum < 1) {
                return '';
            }
            return this.imgUrl + '/' + this.currentPage + '.png';
        },
    },
    watch: {
        // 切换文件时回到第一页
        imgUrl() {
            this.currentPage = 1;
        },
    },
    methods: {
        handlePrev() {
            if (this.currentPage > 1) {
                this.currentPage--;
            }
        },
        handleNext() {
            if (this.currentPage < this.pagesNum) {
                this.currentPage++;
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.fip-container {
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 0;
    display: flex;
    /*防止快速点击切换箭头时误选中图片，浏览器会给选中的图片蒙上深色高亮*/
    user-select: none;
}

.fip-body {
    flex: 1;
    min-height: 0;
    display: flex;
    justify-content: center;
    overflow: auto;
    background: #f2f8ff;
    border-radius: 12px;
}

.fip-image {
    max-width: 100%;
    display: block;
    object-fit: contain;
    /*禁止图片被拖拽，避免拖出半透明残影*/
    -webkit-user-drag: none;
}

/*左右切换图标*/
.fip-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(23, 54, 93, 0.45);
    color: #ffffff;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 2;

    &:hover {
        background: rgba(255, 127, 46, 0.85);
    }
}

.fip-arrow-left {
    left: 16px;
}

.fip-arrow-right {
    right: 16px;
}

.fip-arrow-disabled {
    opacity: 0.4;
    cursor: not-allowed;

    &:hover {
        background: rgba(23, 54, 93, 0.45);
    }
}

/*页码指示*/
.fip-page {
    position: absolute;
    bottom: 12px;
    left: 50%;
    transform: translateX(-50%);
    padding: 2px 12px;
    border-radius: 12px;
    background: rgba(23, 54, 93, 0.45);
    color: #ffffff;
    font-size: 13px;
    z-index: 2;
}
</style>
